import { QueryClient, QueryCache, QueryClientProvider } from "react-query";
import { useLoggedInAs } from "./store/loggedInAs";
import { cookieStorage } from "./utils/cookieStorage";
import { AxiosError } from "axios";
import { useRef } from "react";

function AppQueryClient({ children }: any) {
  const { setToken } = useLoggedInAs();
  let redirecting = false;

  const queryClientRef = useRef<QueryClient>();
  if (!queryClientRef.current) {
    queryClientRef.current = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 60 * 1000,
          refetchOnWindowFocus: false,
          retry: (failureCount, error: unknown) => {
            const axiosError = error as AxiosError;
            const status = axiosError?.response?.status;
            if (status && [401, 403].includes(status)) {
              return false;
            }
            return failureCount < 3;
          },
        },
      },
      queryCache: new QueryCache({
        onError: (error: any) => {
          const errorMessage = error?.response?.data.message;
          const errorCode = error?.response?.data?.status;
          const entryPointUri = cookieStorage.getItemSync("entry-point-uri");
          if (
            (["Token is expired", "Unauthorized"].includes(errorMessage) ||
              ("Token is incorrect" === errorMessage && !entryPointUri)) &&
            errorCode === 401
          ) {
            if (
              !redirecting &&
              !window.location.search.includes("expired=true")
            ) {
              redirecting = true;
              cookieStorage.removeItemSync("persist:root");
              setToken(null);
              queryClientRef.current?.clear();
              window.location.href = "/login?expired=true";
            }
          }
        },
      }),
    });
  }

  return (
    <QueryClientProvider client={queryClientRef.current}>
      {children}
    </QueryClientProvider>
  );
}

export default AppQueryClient;
